import {getIntEnv} from "./ConfigUtils";

export const sectionsWithReviewIds = [
    getIntEnv('REACT_APP_SECTION_CHIP'),
    getIntEnv('REACT_APP_SECTION_SOFTWARE'),
    getIntEnv('REACT_APP_SECTION_DEVICE'),
];
